import { Service } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromExtras from '../actions/extras.action';
import { StateSlice } from '@core/helpers/state-slice';

export type ExtrasState = StateSlice<Service[]>;

export const initialState: ExtrasState = {
  data: [],
  loaded: false,
  loading: false,
  error: null,
};

const extrasReducer = createReducer(
  initialState,
  on(fromExtras.addExtra, (state, { payload }) => {
    const data = [...state.data];
    data.push(payload);

    return {
      ...state,
      data,
      loading: false,
      loaded: true,
    };
  }),
  on(fromExtras.removeExtra, (state, { payload }) => {
    let data = [...state.data];
    data = data.filter(
      (item) => JSON.stringify(item) !== JSON.stringify(payload)
    );

    return {
      ...state,
      data,
      loading: false,
      loaded: true,
    };
  }),
  on(fromExtras.resetExtras, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: ExtrasState | undefined,
  action: fromExtras.ExtrasActions
) {
  return extrasReducer(state, action);
}
